const STORAGE_KEY = 'eventDetailPanel_wide';

/** Reads whether the event detail panel was last used in its wide layout. */
export const loadEventDetailPanelWide = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};

/** Persists the event detail panel width choice. */
export const saveEventDetailPanelWide = (wide: boolean): void => {
    try {
        localStorage.setItem(STORAGE_KEY, String(wide));
    } catch {
        // ignore storage errors (e.g. private mode)
    }
};
